import React from "react"
import types from "prop-types"
import { isEmpty, isEqual, sortBy } from "lodash-es"
import { useSelector } from "react-redux"
import { organizationUsersById } from "reduxSlices/organizationUsersSlice"
import { useTaskFormContext } from "contexts/TaskFormContext"
/* eslint-disable max-len */
import TaskUserList from "views/FormSubmission/FormSubmissionTabs/ActivitiesContent/TaskForms/TaskFields/UI/TaskUserList"
/* eslint-enable max-len */

const TaskMemberList = ({ className = "" }) => {
  const { removeMemberId, taskMemberIds } = useTaskFormContext()
  const members = useSelector(organizationUsersById(taskMemberIds), isEqual)

  if (isEmpty(taskMemberIds)) return null

  const sortedMembers = sortBy(members, ["lastName", "firstName"])

  return (
    <TaskUserList className={className} removeUser={removeMemberId} users={sortedMembers} userDescriptor="member" />
  )
}

TaskMemberList.propTypes = {
  className: types.string,
}

export default TaskMemberList
